"use client";

import { useRef, useState } from "react";
import ChatHome from "~/components/chat/chat-home";
// import DatabaseConnectorMenu from "../database/database-connector-menu";
// import { TbDatabasePlus } from "react-icons/tb";
import LiveSession from "~/components/live-session/live-session";
import CoinUsageButton from "~/components/price-comparison/coin-usage-button";

const SessionContainer = ({
  sessionId,
}: {
  sessionId?: string | undefined;
}) => {
  const [isDatabaseModalOpen, setIsDatabaseModalOpen] = useState(false);
  const databaseModalRef = useRef<HTMLDialogElement>(null);

  const openDatabaseModal = () => {
    setIsDatabaseModalOpen(true);
    databaseModalRef.current?.showModal();
  };

  const closeDatabaseModal = () => {
    setIsDatabaseModalOpen(false);
    databaseModalRef.current?.close();
  };

  return (
    <div className="h-full w-full">
      <CoinUsageButton />
      {sessionId ? (
        <LiveSession sessionId={sessionId} />
      ) : (
        <ChatHome onOpenDatabaseModal={openDatabaseModal} />
      )}
      {/* <DatabaseConnectorMenu
        ref={databaseModalRef}
        isOpen={isDatabaseModalOpen}
        onClose={closeDatabaseModal}
      /> */}
    </div>
  );
};

export default SessionContainer;
